<div
  mat-dialog-content
  class="dialog-content text-dark"
  style="padding: 0 !important; color: initial"
>
  <ng-content></ng-content>
</div>
